import './errorPopover.css'
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import cross from '../../images/cross.png';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export const ErrorPopover = (props) => {
  return (
    <div>
      {/* <div className='cancel-button'> <IconButton aria-label="close" onClick={props.onClose}></IconButton></div> */}
      <div className='error-icon-image'><img src={cross} alt='' /></div>
      <div> <p className='error-popup-text'>{props.title}</p> </div>
    </div>
  );
};
